import { PreviewPage } from '../types';

// Unified preview pages: the cover comes first (page 1), then one page per
// machine QR code — matching "Cover · page 1 of N" then "MACHINE {n}".
export const buildPreviewPages = ({
  hasCoverPreview,
  hasQrPreview,
  coverPdfUrl,
  coverPageCount = 1,
  machines,
  qrSheetUrl
}: {
  hasCoverPreview: boolean;
  hasQrPreview: boolean;
  // The generated dynamic cover-page preview PDF (from /dynamiccoverpage).
  coverPdfUrl?: string;
  // The number of pages in the generated cover PDF (cover + resource pages).
  coverPageCount?: number;
  machines: string[];
  // The generated QR PDF sheet (one document for all nodes), shown on each
  // machine page.
  qrSheetUrl?: string;
}): PreviewPage[] => {
  const pages: PreviewPage[] = [];
  if (hasCoverPreview) {
    // The cover PDF combines the cover + resource pages, so page through all of
    // them ("Cover · page 1 of N").
    Array.from({ length: Math.max(1, coverPageCount) }).forEach((_, index) =>
      pages.push({ label: 'Cover', pdfUrl: coverPdfUrl, pdfPage: index + 1 })
    );
  }
  if (hasQrPreview) {
    // The QR sheet is one PDF with a page per machine (in the entered order),
    // so each machine page targets page index+1 of that document.
    machines.forEach((machine, index) =>
      pages.push({
        label: `MACHINE ${machine}`,
        pdfUrl: qrSheetUrl,
        pdfPage: index + 1
      })
    );
  }
  return pages;
};
